if (!customElements.get('warm-weather-packaging')) {
  customElements.define(
    'warm-weather-packaging',
    class WarmWeatherPackaging extends HTMLElement {
      constructor() {
        super();

        // close other details elements on toggle event
        this.addEventListener('toggle', (event) => {
          const targetDetails = event.target;

          if (targetDetails.tagName === 'DETAILS' && targetDetails.open) {
            document.querySelectorAll('details[open]').forEach((openDetails) => {
              if (openDetails !== targetDetails) {
                openDetails.open = false;
              }
            });
          }
        }, true);

        this.setupEventListeners();
      }

      setupEventListeners() {
        this.addEventListener('click', (event) => {
          const addButton = event.target.closest('#AddWarmWeatherBtn');
          if (addButton) {
            this.addToCart();
          }
        });
      }

      addToCart() {
        const addBtn = this.querySelector('#AddWarmWeatherBtn');
        if (!addBtn) return;

        const variantId = addBtn.dataset.variantId;
        const currentQuantity = parseInt(addBtn.dataset.cartQuantity || '0', 10);
        const minQuantity = parseInt(addBtn.dataset.min || '', 10);
        const maxQuantity = parseInt(addBtn.dataset.max || '', 10);
        const quantityToAdd = Number.isNaN(minQuantity) ? 1 : Math.max(minQuantity, 1);
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        if (!Number.isNaN(maxQuantity) && currentQuantity + quantityToAdd > maxQuantity) {
          addBtn.textContent = `Limit reached (${maxQuantity})`;
          addBtn.disabled = true;
          return;
        }

        // Disable button and show loading state
        addBtn.disabled = true;
        addBtn.textContent = 'Adding...';

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', quantityToAdd);

        if (cart) {
          formData.append(
            'sections',
            cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              console.error('Error adding warm weather packaging:', response.description || response.message);
              addBtn.disabled = false;
              addBtn.textContent = 'Add Warm Weather Packaging';
              return;
            }

            if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (window.publish && window.PUB_SUB_EVENTS) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'warm-weather-packaging',
                productVariantId: variantId,
                cartData: response,
              });
            }

            const nextQuantity = currentQuantity + quantityToAdd;
            addBtn.dataset.cartQuantity = String(nextQuantity);

            if (!Number.isNaN(maxQuantity) && nextQuantity >= maxQuantity) {
              addBtn.textContent = `Limit reached (${maxQuantity})`;
              addBtn.disabled = true;
            }

            cart.renderContents(response);
          })
          .catch((error) => {
            console.error('Error adding warm weather packaging:', error);
            addBtn.disabled = false;
            addBtn.textContent = 'Add Warm Weather Packaging';
          })
          .finally(() => {
            setTimeout(() => {
              const hasReachedMax =
                !Number.isNaN(maxQuantity) && parseInt(addBtn.dataset.cartQuantity || '0', 10) >= maxQuantity;
              addBtn.disabled = hasReachedMax;
              addBtn.textContent = hasReachedMax ? `Limit reached (${maxQuantity})` : 'Add Warm Weather Packaging';
            }, 500);
          });
      }
    }
  );
}
